/*
  This file contains the logic for the cabinet form. 
 */

(function () {

  let select_equal_drawer_height = jQuery("#Web_Equal_Drawers_input");
  let top_drawer_height_field = jQuery('#form_input_Top_Drawer_Front_Height');

  // listen for the change event on the select equal drawer height checkbox
  select_equal_drawer_height.change(function () {
    if (select_equal_drawer_height.is(":checked")) {
      // hide the top drawer height field
      top_drawer_height_field.hide();

    } else {
      // show the top drawer height field
      top_drawer_height_field.show();
    }
  });

})();